import { useQuery } from "@tanstack/react-query"
import { getAllComplains } from "@/lib/api/complain.api"
import { useAuthStore } from "@/store/auth.store"

export function useGetAllComplains(enabled = true) {
  const accessToken = useAuthStore((s) => s.accessToken)

  return useQuery({
    queryKey: ["all-complains"],
    queryFn: () => getAllComplains(accessToken!),
    enabled: !!accessToken && enabled,
    staleTime:0,
  })
}
